import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="accordion"
// Fecha os outros itens quando um é aberto. Usar com ui--disclosure nos filhos.
export default class extends Controller {
  closeOthers(event) {
    const clickedEl = event.target.closest('[data-controller*="ui--disclosure"]')

    this.element.querySelectorAll('[data-controller*="ui--disclosure"]').forEach(el => {
      if (el !== clickedEl) {
        this.application.getControllerForElementAndIdentifier(el, "ui--disclosure")?.close()
      }
    })
  }
}
